export const ACCOUNT_TAGS_OPEN_CREATE_EDIT_MODAL = "ACCOUNT_TAGS_OPEN_CREATE_EDIT_MODAL";

export const ACCOUNT_TAGS_SAVE_TAG = "ACCOUNT_TAGS_SAVE_TAG";
export const ACCOUNT_TAGS_SAVE_TAG_RESPONSE = "ACCOUNT_TAGS_SAVE_TAG_RESPONSE";

export const ACCOUNT_TAGS_GET_TAG = "ACCOUNT_TAGS_GET_TAG";
export const ACCOUNT_TAGS_GET_TAG_RESPONSE = "ACCOUNT_TAGS_GET_TAG_RESPONSE";

export const ACCOUNT_TAGS_GET_ENTITIES = "ACCOUNT_TAGS_GET_ENTITIES";
export const ACCOUNT_TAGS_GET_ENTITIES_RESPONSE = "ACCOUNT_TAGS_GET_ENTITIES_RESPONSE";